/**
 * GD Video Player — custom controls, play overlay, and fade-out behavior.
 * Loaded as an external asset to avoid inline <script> rendering issues
 * inside overflow:hidden containers.
 */
(function() {
  function initGdVideoPlayer(container) {
    var videoPlayer = container.querySelector('video');
    if (!videoPlayer) return null;

    /* Bind once per wrapper. Prevents double-bound listeners (which cancel
       each other out — a click that pauses then instantly plays, or a mute
       toggle that nets no change) when the player is initialised by more than
       one path (global auto-init + a section re-init, Splide clones, etc.). */
    if (container.__gdVideoBound) return videoPlayer;
    container.__gdVideoBound = true;

    /* --- Autoplay: skip all control setup, just ensure play() fires --- */
    if (container.dataset.autoplay === 'true') {
      videoPlayer.muted = true;
      var playPromise = videoPlayer.play();
      if (playPromise !== undefined) {
        playPromise.catch(function() {
          // Autoplay blocked — video stays on poster, no error thrown
        });
      }
      return videoPlayer;
    }

    var playButton = container.querySelector('.gd-video__play-button');
    var muteBtn    = container.querySelector('.gd-video__mute-btn');
    var timeline   = container.querySelector('.gd-video__timeline');
    var controls   = container.querySelector('.gd-video__controls');
    var fadeOutTimeout;

    function syncPlayButton() {
      if (!playButton) return;
      playButton.classList.toggle('gd-video__play-button--hidden', !videoPlayer.paused);
    }
    videoPlayer.addEventListener('play', syncPlayButton);
    videoPlayer.addEventListener('pause', syncPlayButton);
    videoPlayer.addEventListener('ended', syncPlayButton);

    function setMuted(muted) {
      videoPlayer.muted = muted;
      if (!muteBtn) return;
      muteBtn.classList.toggle('gd-video__mute-btn--muted', muted);
      muteBtn.classList.toggle('gd-video__mute-btn--unmuted', !muted);
      muteBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
    }

    /* Clicking play is a user gesture (this isn't autoplay mode), so we can
       turn the sound on — play automatically unmutes. */
    function playVideo() {
      setMuted(false);
      var p = videoPlayer.play();
      if (p && p.catch) p.catch(function() {});
    }

    /* --- Play button --- */
    if (playButton) {
      playButton.addEventListener('click', function(e) {
        e.stopPropagation();
        playVideo();
      });
    }

    /* --- Whole media area toggles play/pause, except the custom controls
       (timeline / mute) and the play button. --- */
    container.addEventListener('click', function(e) {
      if (e.target.closest('.gd-video__controls')) return;
      if (e.target.closest('.gd-video__play-button')) return;
      if (videoPlayer.paused) {
        playVideo();
      } else {
        videoPlayer.pause();
      }
    });

    /* --- Mute / Unmute --- */
    if (muteBtn) {
      muteBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        setMuted(!videoPlayer.muted);
      });
    }

    /* --- Timeline --- */
    if (timeline) {
      videoPlayer.addEventListener('timeupdate', function() {
        if (videoPlayer.duration) {
          timeline.value = (videoPlayer.currentTime / videoPlayer.duration) * 100;
        }
      });
      /* Scrub in place — move the playhead, never pause. */
      timeline.addEventListener('input', function() {
        if (videoPlayer.duration) {
          videoPlayer.currentTime = (timeline.value / 100) * videoPlayer.duration;
        }
      });
    }

    /* --- Fade-out controls (2s inactivity) --- */
    if (controls) {
      function startFadeOutTimer() {
        clearTimeout(fadeOutTimeout);
        fadeOutTimeout = setTimeout(function() {
          controls.classList.add('gd-video__controls--fade-out');
        }, 2000);
      }
      function stopFadeOutTimer() {
        controls.classList.remove('gd-video__controls--fade-out');
        clearTimeout(fadeOutTimeout);
      }

      container.addEventListener('mousemove', stopFadeOutTimer);
      container.addEventListener('mousemove', function() { startFadeOutTimer(); });
      container.addEventListener('mouseleave', function() { startFadeOutTimer(); });
      container.addEventListener('touchstart', stopFadeOutTimer);
      container.addEventListener('touchend', function() { startFadeOutTimer(); });

      startFadeOutTimer();
    }

    return videoPlayer;
  }

  /* Expose globally so sections can call it (e.g. after Splide remount) */
  window.initGdVideoPlayer = initGdVideoPlayer;

  /** Init all uninitialized gd-video wrappers */
  function initAllGdVideos() {
    var containers = document.querySelectorAll('.gd-video-wrapper:not([data-gd-video-initialized])');
    containers.forEach(function(container) {
      initGdVideoPlayer(container);
      container.dataset.gdVideoInitialized = 'true';
    });
  }

  /* Auto-init on DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGdVideos);
  } else {
    initAllGdVideos();
  }

  /* Shopify design mode: re-init on section load */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllGdVideos);
  }
})();